// called logged to avoid IDEs detecting the "logs" directory as ignorable
export * as logs from "./logging"
